"use client";

import { CountryInfo } from "@/store/types/countryTypes";
import React from "react";

const CountryWhyStudy: React.FC<{ country: CountryInfo }> = ({ country }) => {
  const sectionData = country?.whyStudyReasons;
  const reasons = sectionData?.reasons || [];

  if (reasons.length === 0) {
    return null;
  }

  const heading =
    sectionData?.heading ||
    `Why Study in ${country.countryName} for International Students`;
  const subheading =
    sectionData?.subheading ||
    `Beyond the rankings - the practical reasons students choose ${country.countryName} over other destinations.`;

  return (
    <div className="w-full my-12 space-y-6">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-[#1C2233] ff_poppins">
          {heading}
        </h2>
        {subheading && (
          <p className="mt-1.5 text-xs sm:text-sm text-[#667085] ff_poppins">
            {subheading}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {reasons.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-[18px] border border-[#E0D8FF] p-5 sm:p-6 flex items-start gap-4 shadow-sm hover:shadow-md transition-shadow"
          >
            <span className="text-2xl sm:text-3xl font-extrabold text-[#997AFF] ff_poppins shrink-0 leading-none">
              {item.number || `0${index + 1}`}
            </span>
            <div>
              <h3 className="text-base sm:text-lg font-bold text-[#1C2233] ff_poppins">
                {item.title}
              </h3>
              <p className="mt-1 text-xs sm:text-sm text-[#525B73] ff_poppins leading-relaxed">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountryWhyStudy;

